import React, { useState } from 'react';
import '../styles/DenyModal.css';

const DENY_REASONS = {
  MISSION_MISALIGNMENT: {
    label: "Mission Misalignment",
    text: "The project's mission falls outside the scope of our designated charitable mission, as outlined by our 501(c)(3) compliance obligations."
  },
  PRIVATE_BENEFIT: {
    label: "Private Benefit or Inurnment",
    text: "The project raises concerns regarding potential private inurement or benefit, which could jeopardize compliance with IRS 501(c)(3) regulations."
  },
  NON_CHARITABLE: {
    label: "Non-Charitable Purpose",
    text: "The project's purpose does not align with the IRS definition of charitable activities under 501(c)(3) guidelines."
  },
  FUNDING: {
    label: "Funding Sustainability",
    text: "The project does not currently demonstrate a sustainable financial plan, which is essential for effective fiscal sponsorship."
  },
  INCOMPLETE: {
    label: "Incomplete Proposal",
    text: "The application did not provide sufficient information for a thorough review."
  },
  GEOGRAPHIC: {
    label: "Geographic Scope",
    text: "The project operates outside of the geographic areas we are equipped to support."
  },
  ADMINISTRATIVE: {
    label: "Excessive Administrative Burden",
    text: "The project's administrative requirements exceed the resources available under our fiscal sponsorship."
  }
};

const DenyModal = ({ application, onClose, onConfirm }) => {
  const [selectedReason, setSelectedReason] = useState('');
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const handleDeny = async () => {
    if (!selectedReason) {
      alert('Please select a denial reason');
      return;
    }

    setIsConfirmOpen(true);
  };

  const handleConfirmDeny = async () => {
    try {
      const response = await fetch('/api/applications/deny', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          applicationId: application._id,
          denyReason: DENY_REASONS[selectedReason].text,
          applicantName: application.applicant?.name,
          applicantEmail: application.applicant?.email,
          causeName: application.project?.name
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to process denial');
      }

      onConfirm();
      onClose();
    } catch (error) {
      console.error('Error processing denial:', error);
      alert('Failed to process denial. Please try again.');
    }
  };

  return (
    <div className="deny-modal-overlay">
      <div className="deny-modal-content">
        <h2>Deny Application</h2>
        
        {!isConfirmOpen ? (
          <>
            <p>Please select the reason for denial:</p>
            <select 
              value={selectedReason} 
              onChange={(e) => setSelectedReason(e.target.value)}
              className="deny-reason-select"
            >
              <option value="">Select a reason...</option>
              {Object.entries(DENY_REASONS).map(([key, { label }]) => (
                <option key={key} value={key}>{label}</option>
              ))}
            </select>
            
            {selectedReason && (
              <div className="reason-preview">
                <p><strong>Selected Reason:</strong></p>
                <p>{DENY_REASONS[selectedReason].text}</p>
              </div>
            )}

            <div className="deny-modal-actions">
              <button 
                className="deny-btn" 
                onClick={handleDeny}
                disabled={!selectedReason}
              >
                Proceed with Denial
              </button>
              <button className="cancel-btn" onClick={onClose}>
                Cancel
              </button>
            </div>
          </>
        ) : (
          <div className="confirm-denial">
            <p>Are you sure you want to deny this application?</p>
            <p>An email will be sent to:</p>
            <p><strong>{application.applicant?.email}</strong></p>
            <div className="deny-modal-actions">
              <button 
                className="deny-btn" 
                onClick={handleConfirmDeny}
              >
                Confirm Denial
              </button>
              <button 
                className="cancel-btn" 
                onClick={() => setIsConfirmOpen(false)}
              >
                Back
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DenyModal; 